<template>
  <div class="video" 
       ref="video" 
       v-bind:id="this.id" 
       v-bind:class="{ 
         'local': this.isLocalVideo, 
         'camOff': this.offVideo, 
         'talking': this.isTalking, 
         'networkCheck': this.isNetworkBad }">
    <canvas ref="canvas" v-bind:style="{'display': 'none'}" hidden></canvas>
<!--    <canvas ref="canvas" v-bind:style="{'display': isBlur ? 'block' : 'none'}"></canvas>-->
    <!--    <div style="color: greenyellow; position:absolute; bottom: 50px" v-if="report">{{ report }}</div>-->
    <div class="volume">
      <div class="percent">
        <span></span><span></span><span></span><span></span>
      </div>
    </div>
    <div class="loading" v-if="isNetworkBad">
      <p>인터넷 상태가 좋지 않아 영상 송출이 잠시 중단됩니다.</p>
    </div>
    <div class="userContainer">
      <div class="user">
        <span class="name" v-bind:class="{ 'micOff': offMic }">{{ name }}</span>
        <button v-if="id === 'local'" @click="handleChangeName">이름변경</button>
      </div>
    </div>
  </div>
</template>

<script>
import { eBus } from '../commons/eventBus';
import config from "../config";
import store from "../store";
import {sendMessage} from "../commons/message";
import mobile from "../commons/mobile";

export default {
  props: { isLocal: Boolean, isOffVideo: Boolean, isOffMic: Boolean, isBgBlur: Boolean, vid: String, userName: String },
  data() {
    return {
      loaded: false,
      isLocalVideo: this.isLocal,
      id: this.isLocal ? 'local' : this.vid,
      name: this.userName,
      offVideo: this.isOffVideo,
      offMic: this.isOffMic,
      isBlur: this.isBgBlur,
      isTalking: false,
      isNetworkBad: false,
      report: null,
      bytes: 0,
      packets: 0,
      isStartFromPopup: false,
    }
  },
  mounted() {
    this.attachVideo(this.isOffVideo);
    // if (!this.isOffVideo) this.attachVideo();

    //network condition check
    eBus.$on('networkCondition', async param => {
      if (param.userId === this.id) {

        //when network condition is bad
        if(param.hasOwnProperty('isGood') && !param.isGood ){
          this.isNetworkBad = true;

          //camera
          this.offVideo = false;

          this.$refs.video.querySelector('video').style = `display: none`;

        }
        //when network condition is good
        else if(param.hasOwnProperty('isGood') && param.isGood){

          this.isNetworkBad = false;

          if(!store.state.videoStatus[this.id].cam){
            this.offVideo = true;
          } else {
            this.$refs.video.querySelector('video').style = `display: block`;
          }
        }
      }
    })

    //화자감지 기능 분리
    eBus.$on('showsSpeaker', async param => {
      //local video event 지속적인 처리 필요
      this.isLocalVideo = this.id === 'local' && (!this.$store.state.roomInfo.count || this.$store.state.roomInfo.count <= 2) && !this.$store.state.streamInfo.screen;
      if (param.hasOwnProperty('setShows') && !param.setShows) this.isTalking = false; //화자감지 표시 중 기능 off 시 효과 없애기
      if (param.hasOwnProperty('userId') && param.hasOwnProperty('isTalking') && param.userId === this.id) {
        console.debug('isTalking : ', param.isTalking, ' / userId : ', param.userId)
        this.isTalking = param.isTalking; //화자감지 on
      }
    });

    eBus.$on('setVideo', async param => {
      // 200618 ivypark, v0.9.2. 1:1 공유 중 cam/mic off 시 로컬화면이 분리되는 현상 수정
      this.isLocalVideo = this.id === 'local' && (!this.$store.state.roomInfo.count || this.$store.state.roomInfo.count <= 2) && !this.$store.state.streamInfo.screen;

      if (param.id === this.id && param.hasOwnProperty('name')) this.name = param.name;
      if (param.id === this.id && param.hasOwnProperty('isOffMic')) this.offMic = param.isOffMic;
      if (param.id === this.id && param.hasOwnProperty('isOffVideo')) {
        // 200702 ivypark, v1.0.1. 비디오 off 시 소리 들리지 않는 현상 수정. (기존 비디오 삭제 -> display: none, block으로 변경되도록 수정)
        this.$refs.video.querySelector('video').style = param.isOffVideo ? `display: none` : `display: block`;
        this.offVideo = param.isOffVideo;
      }
      if (param.id === this.id && param.hasOwnProperty('deviceSetting')) {
        this.$refs.video.querySelector('video').muted = true;
        if (param.deviceSetting.stream) {
          this.$refs.video.querySelector('video').srcObject = null;
          this.$refs.video.querySelector('video').srcObject = param.deviceSetting.stream;
          await this.$refs.video.querySelector('video').play();
        }
        if (param.deviceSetting.hasOwnProperty('done')) {
          // 자기 목소리 들리는 현상 수정
          if(param.deviceSetting.done === true) this.isStartFromPopup = true;
          if(this.isStartFromPopup === false) this.$refs.video.querySelector('video').muted = param.deviceSetting.done;
        }
        if (param.deviceSetting.hasOwnProperty('sinkId')) await this.$refs.video.querySelector('video').setSinkId(param.deviceSetting.sinkId);
      }
      if (param.id === this.id && param.hasOwnProperty('isBlur')) {
        // 201027 ivypark, v1.1.7. 사생활 보호 기능 추가
        this.isBlur = param.isBlur;
        this.isBlur ? this.blur() : this.unblur();
      }
    })
  },
  destroyed() {
    this.unblur();
  },
  methods: {
    async attachVideo(isOff) {
      let video = document.createElement('video');
      video.srcObject = this.$store.state.streamInfo[this.isLocalVideo ? 'local' : (this.$store.state.roomInfo.type === 'p2p' ? 'remote' : this.id)];
      video.autoplay = true;
      video.muted = this.isLocalVideo;
      video.playsInline = true;
      if (this.$refs.video.firstChild) this.$refs.video.insertBefore(video, this.$refs.video.firstChild);
      // 200714 ivypark, v1.0.7. 화면 off후 신규 참가자 입장 시 카메라 화면이 출력되지 않는 문제 수정
      this.$refs.video.querySelector('video').style = isOff ? `display: none` : `display: block`;
      this.$refs.video.querySelector('video').onloadeddata = () => {
        this.loaded = true;
      }
      if (this.isBlur) await this.blur();
    },
    handleChangeName() {
      eBus.$emit('popup', {
        on: true,
        type: 'ChangeName',
        title: this.$t('popup-change-name-title'),
        ok: (param) => {
          this.name = param.name;
        }
      })
    },
    blur() {
      cocolib.privacyMode.start(store.state.peerInfo['local'], this.$refs.canvas, this.$refs.video.querySelector('video'), { width: 960, height: 540 }, 19, 5, false);
      eBus.$emit('toast', '사생활 보호 기능 로딩 중입니다. 잠시만 기다려주세요.');
    },
    unblur() {
      cocolib.privacyMode.stop(store.state.peerInfo['local'], store.state.streamInfo['local']);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Video.vue